module.exports = __webpack_public_path__ + "static/media/fa_helpdesk_team.ce1c1de2.png";